/* eslint-disable no-alert */
import Vue from 'vue';
import FormDataService from 'services/form-data.service';
import AddEditMixin from '../shared/AddEditMixin';
import AddEditForm from '../shared/AddEditForm';
import FluidConstants from '../../constants/column-name/fluid.column-name.constants';
import FluidFormConstants from '../../constants/form/fluid.form.constants';
import FluidTypeConstants from '../../constants/fluid-types.constants';
import FluidClassConstants from '../../constants/fluid-class.constants';
import FluidManufacturerEndpointConstants from '../../constants/api/endpoint/fluid-manufacturer.endpoint.constants';
import FluidBrandEndpointConstants from '../../constants/api/endpoint/fluid-brand.endpoint.constants';
import FluidWeightEndpointConstants from '../../constants/api/endpoint/fluid-weight.endpoint.constants';
import AutoComplete from '../shared/AutoComplete.vue';
import Mappings from '../oil-sample/SampleDetail/OilSampleAutoCompleteMaps';
import AjaxDataService from '../../../services/ajax.service';
import GlobalStore from '../../../store';

export default Vue.extend({
  name: FluidFormConstants.FormName,
  props: {
    isEditMode: {
      type: Boolean,
      default: false
    },
    startingFluidTypeID: {
      type: Number,
      default: FluidTypeConstants.OilId
    }
  },
  data() {
    return {
      formData: {},
      mappings: Mappings,
      globalStore: GlobalStore
    };
  },
  computed: {
    formTitle() {
      return this.isEditMode ? 'Edit Fluid' : 'Add Fluid';
    },
    isCoolant() {
      return this.formData.fluidTypeID === FluidTypeConstants.CoolantId;
    },
    showFluidWeight() {
      return !this.isCoolant && this.formData.fluidClass !== FluidClassConstants.NA;
    }
  },
  mixins: [AddEditMixin],
  methods: {
    checkForm() {
      return this.checkFormSubmission(FluidConstants);
    },
    openDialog(data) {
      this.globalStore.state.AutoCompletes.FluidBrand.dataSource = [];
      const fluidTypeId = data?.fluidTypeID || this.startingFluidTypeID;
      this.formData = {
        ...data,
        fluidManufacturerName: data?.fluidManufacturerName,
        fluidManufacturerID: data?.fluidManufacturerID,
        fluidBrandName: data?.fluidBrandName,
        fluidBrandID: data?.fluidBrandID,
        fluidClass: data?.fluidClass,
        fluidClassID: data?.fluidClassID,
        fluidWeightName: data?.fluidWeightName,
        fluidWeightID: data?.fluidWeightID,
        fluidTypeID: data?.fluidTypeID || fluidTypeId,
        fluidTypeName: data?.fluidTypeName,
        fluidBaselineSampleID: data?.fluidBaselineSampleID,
        fluidBaselineSampleNumber: data?.fluidBaselineSampleNumber,
        fluidBaselineSampleDate: data?.fluidBaselineSampleDate
      };

      if (this.mappings !== undefined) {
        this.loadMappedAutoCompletes(this.mappings, this.formData);
      }

      this.$nextTick(() => {
        this.$refs.addEditForm.openDialog(this.formData);
      });
    },
    typeChange() {
      if (this.formData.fluidTypeName) {
        if (this.formData.fluidTypeName === FluidTypeConstants.Coolant) {
          this.formData.fluidTypeID = FluidTypeConstants.CoolantId;
          this.formData.fluidTypeCode = FluidTypeConstants.Coolant.toLocaleLowerCase();
        } else {
          this.formData.fluidTypeID = FluidTypeConstants.OilId;
          this.formData.fluidTypeCode = FluidTypeConstants.Oil.toLocaleLowerCase();
        }
        this.formData.fluidWeight = null;
        this.formData.fluidWeightName = null;
        this.formData.fluidWeightID = null;
        this.formData.fluidClass = FluidClassConstants.NA;
        this.formData.fluidClassID = null;
        this.formData.fluidBrandName = null;
        this.formData.fluidBrandID = null;
      }
    },
    classChange() {
      this.formData.fluidClass = this.formData?.fluidClass?.toUpperCase();
      this.globalStore.state.AutoCompletes.FluidWeight.dataSource = [];
      this.formData = {
        ...this.formData,
        fluidWeightName: null,
        fluidWeightID: null
      };
      if (!Object.values(FluidClassConstants).includes(this.formData.fluidClass)) {
        this.formData.fluidClass = FluidClassConstants.NA;
      }
      if (this.formData.fluidClass === FluidClassConstants.SAE) {
        this.formData.fluidClassID = 1;
      } else if (this.formData.fluidClass === FluidClassConstants.ISO) {
        this.formData.fluidClassID = 2;
      } else {
        this.formData.fluidClassID = null;
      }
    },
    async handleCreateNewItem(newItemName, itemFieldID) {
      switch (itemFieldID) {
        case Mappings.FluidManufacturer.lookups.idField:
          await AjaxDataService.postData(FluidManufacturerEndpointConstants.create, {
            FluidManufacturerName: newItemName
          })
            .then(response => {
              if (response.data) {
                this.formData.fluidManufacturerID = response.data?.fluidManufacturerID;
                this.formData.fluidManufacturerName = response.data?.fluidManufacturerName;
              }
            })
            .catch(() => {
              window.alert('Failed to create manufacturer');
            });
          break;
        case Mappings.FluidBrand.lookups.idField:
          await AjaxDataService.postData(FluidBrandEndpointConstants.create, {
            FluidBrandName: newItemName,
            FluidTypeID: this.formData.fluidTypeID
          })
            .then(response => {
              if (response.data) {
                this.formData.fluidBrandID = response.data?.fluidBrandID;
                this.formData.fluidBrandName = response.data?.fluidBrandName;
              }
            })
            .catch(() => {
              window.alert('Failed to create brand');
            });
          break;
        case Mappings.FluidWeight.lookups.idField:
          await AjaxDataService.postData(FluidWeightEndpointConstants.create, {
            FluidWeightName: newItemName
          })
            .then(response => {
              if (response.data) {
                this.formData.fluidWeightID = response.data?.fluidWeightID;
                this.formData.fluidWeightName = response.data?.fluidWeightName;
              }
            })
            .catch(() => {
              window.alert('Failed to create weight');
            });
          break;
        default:
          window.alert('Failed to create new item');
      }
    }
  },
  components: {
    AddEditForm,
    AutoComplete
  },
  beforeCreate() {
    // eslint-disable-next-line global-require
    this.$options.components.AutoComplete = require('../shared/AutoComplete.vue').default;
  },
  template: `
    <AddEditForm :title="formTitle" ref="addEditForm" @submit-button-clicked="onFormSubmit">
    <span class="radio-margin-right">${FormDataService.radioInput(
      FluidTypeConstants.Oil,
      FluidConstants.fluidTypeName.field,
      'typeChange'
    )}</span>
      ${FormDataService.radioInput(FluidTypeConstants.Coolant, FluidConstants.fluidTypeName.field, 'typeChange')}
      <AutoComplete
        :formData="formData"
        :mapping="mappings.FluidManufacturer"
        :hasDescription="true"
        :clearRightPadding="true"
        :removeOptionsLimit="true"
        store="FluidManufacturer"
        :allowCreateNew="true"
        createNewItemText="Add New Manufacturer"
        @create-new-item="handleCreateNewItem"
        placeholder="Select Fluid Manufacturer">
        Fluid Manufacturer
      </AutoComplete>
      <AutoComplete
        :formData="formData"
        :mapping="mappings.FluidBrand"
        :hasDescription="true"
        :clearRightPadding="true"
        :removeOptionsLimit="true"
        store="FluidBrand"
        :fluidInfo="{
          fluidTypeID: formData.fluidTypeID ?? 1,
        }"
        :allowCreateNew="true"
        createNewItemText="Add New Brand"
        @create-new-item="handleCreateNewItem"
        placeholder="Select Fluid Brand">
        Fluid Brand
      </AutoComplete>
      <div v-if="!isCoolant">
         ${FormDataService.radioInput(FluidClassConstants.NA, FluidConstants.fluidClass.field, 'classChange')}
          <span class="radio-margin-x">${FormDataService.radioInput(
            FluidClassConstants.SAE,
            FluidConstants.fluidClass.field,
            'classChange'
          )}</span>
          ${FormDataService.radioInput(FluidClassConstants.ISO, FluidConstants.fluidClass.field, 'classChange')}
      </div>
      <div v-if="showFluidWeight">
        <AutoComplete
          :formData="formData"
          :mapping="mappings.FluidWeight"
          :hasDescription="true"
          :clearRightPadding="true"
          :removeOptionsLimit="true"
          store="FluidWeight"
          :allowCreateNew="true"
          :fluidInfo="{
          fluidClass: formData.fluidClass ?? '',
          }"
          createNewItemText="Add New Weight"
          @create-new-item="handleCreateNewItem"
          placeholder="Select Fluid Weight">
          Fluid Weight
        </AutoComplete>
      </div>
      ${FormDataService.textInput(FluidConstants.fluidKeywords)}
      ${FormDataService.textareaInput(FluidConstants.fluidComments)}
      <p v-if="!isEditMode" class="helper-text">
        Once New Fluid is added to the system, you will be able to add a Baseline Sample
      </p>
      <div v-if="isEditMode">
        <AutoComplete
          :formData="formData"
          :mapping="mappings.FluidBaselineSample"
          :hasDescription="true"
          :clearRightPadding="true"
          :removeOptionsLimit="true"
          :searchOnOpen="true"
          :fluidInfo="{
            fluidType: isCoolant ? 'Coolant' : 'Oil',
            fluidId: formData.fluidID,
          }"
          :linkToItem="{
          location: isCoolant ? 'coolant-samples' : 'oil-samples',
          id: formData.fluidBaselineSampleID,
          label: isCoolant ? 'Go To Coolant Sample' : 'Go to Oil Sample'
          }"
          store="FluidBaselineSample"
          placeholder="Select Baseline Sample Number">
          Baseline Sample {{ isCoolant ? 'Coolant' : 'Oil' }} Number
        </AutoComplete>
      </div>
    </AddEditForm>
  `
});
